export default __webpack_public_path__ + "static/media/multi-route.25139c24.svg";